import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vShow as _vShow, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "entity-index-table-controls block" }
const _hoisted_2 = { class: "filter-controls" }
const _hoisted_3 = { class: "field is-horizontal has-addons" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "field-label is-small" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Titulo")
], -1)
const _hoisted_5 = { class: "field-body" }
const _hoisted_6 = { class: "control" }
const _hoisted_7 = { class: "control" }
const _hoisted_8 = { class: "field is-horizontal cant-page-container" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "field-label is-small" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Cant. página")
], -1)
const _hoisted_10 = { class: "field-body" }
const _hoisted_11 = { class: "actions-buttons-container" }
const _hoisted_12 = { class: "icon is-small" }
const _hoisted_13 = { class: "message" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("progress", {
  class: "progress is-primary",
  max: "100"
}, " 15% ", -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 1,
  class: "message-body"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_i_frame = _resolveComponent("vue-i-frame")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_paginated_table = _resolveComponent("paginated-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                class: "input",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.videoInputVal) = $event)),
                placeholder: "Juntos crecemos por Panamá"
              }, null, 512), [
                [_vModelText, _ctx.videoInputVal]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                class: _normalizeClass(["button is-info", { 'is-loading': _ctx.loadingData }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.initData()))
              }, " Buscar ", 2)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _withDirectives(_createElementVNode("input", {
            class: "input",
            type: "number",
            min: "1",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cantPageInputVal) = $event))
          }, null, 512), [
            [_vModelText, _ctx.cantPageInputVal]
          ])
        ])
      ])
    ]),
    (_ctx.elements.length != 0)
      ? (_openBlock(), _createBlock(_component_paginated_table, {
          key: 0,
          "is-loading": _ctx.loadingData,
          "columns-config": _ctx.tableColumnsConfig,
          "async-pagination-state": _ctx.driver?.asyncPaginationState,
          elements: _ctx.elements,
          "current-page": _ctx.currentPage,
          "page-size": _ctx.pageSize,
          onPaginationClick: _ctx.onPaginationClick
        }, {
          preview: _withCtx(({ row: video }) => [
            _createVNode(_component_vue_i_frame, {
              src: video.url
            }, null, 8, ["src"])
          ]),
          actions: _withCtx(({ row: entity }) => [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_router_link, {
                class: "button is-info",
                to: {
            name: 'public-video-show',
            params: { videoId: entity.id },
          },
                title: `Ver ${entity.title}`
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_12, [
                    _createVNode(_component_svg_icon, {
                      type: "mdi",
                      path: _ctx.mdiEye
                    }, null, 8, ["path"])
                  ])
                ]),
                _: 2
              }, 1032, ["to", "title"])
            ])
          ]),
          _: 1
        }, 8, ["is-loading", "columns-config", "async-pagination-state", "elements", "current-page", "page-size", "onPaginationClick"]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("article", _hoisted_13, [
      (_ctx.loadingData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
        : (_openBlock(), _createElementBlock("div", _hoisted_17, " No hay videos actualmente. "))
    ], 512), [
      [_vShow, !_ctx.elements.length]
    ])
  ], 64))
}